import {computedFrom, inject, TaskQueue} from 'aurelia-framework';
import {EventAggregator, Subscription} from 'aurelia-event-aggregator';
import {ContentService} from '../../../../../services/content-service';
import {GroupService, isGroupDefaultOrDummy} from '../../../../../services/group/group-service';
import {User, UserDetails} from '../../../../../services/user-service';
import {CurrentGroup} from '../../../../../services/group/current-group';
import {SelectEvent} from '../../../../../broadcast/group-events';
import {GroupEventBus} from '../../../../../broadcast/group-event-bus';
import {SmDeviceDetected} from '../../../../../tools/sm-device-detected';
import {AureliaConfiguration} from 'aurelia-configuration';
import {capitalize, defaults, delay, get, take} from 'lodash';

@inject(ContentService, TaskQueue, GroupService, EventAggregator, CurrentGroup, GroupEventBus, SmDeviceDetected, AureliaConfiguration, UserDetails)
export class GroupViewHeader {

  groupPath = [];
  pathLimit = 3;
  atApplication = false;
  atDirectory = false;
  atSettings = false;
  atReports = false;
  atBilling = false;
  justCreated = false;
  isReportsEnabled: boolean;
  userData: Partial<User>;
  groupData: any;

  private __selectSubscription: Subscription;

  constructor(public contentService: ContentService, public taskQueue: TaskQueue, public groupService: GroupService, public eventAggregator: EventAggregator, private __currentGroup: CurrentGroup, private __groupEventBus: GroupEventBus, public smDeviceDetected: SmDeviceDetected, config: AureliaConfiguration, userDetails: UserDetails) {
    this.isReportsEnabled = config.get('reports.enabled') || false;
    // @ts-ignore
    this.userData = userDetails ? userDetails.__data : {};
    // this.hasSubscription = false;
  }

  @computedFrom('groupPath')
  get selectedGroup() {
    return this.groupPath[this.groupPath.length - 1] || {};
  }

  @computedFrom('selectedGroup', 'justCreated')
  get isButtonsVisible() {
    return !this.justCreated && !isGroupDefaultOrDummy(this.selectedGroup.id);
  }

  @computedFrom('selectedGroup')
  get isGlobalAdmin() {
    return this.selectedGroup.isGlobalAdmin;
  }
  @computedFrom('selectedGroup')
  get isMember() {
    return this.selectedGroup.isMember;
  }
  @computedFrom('selectedGroup')
  get canShowReports() {
    return this.isReportsEnabled && this.selectedGroup.isGlobalAdmin;
  }

  @computedFrom('selectedGroup')
  get hasSubscription() {
    return this.selectedGroup.billingEnabled;
  }

  bind() {
    this.__currentGroup.onReady().then(() => delay(() => {
      this.handleCurrentGroup(this.__currentGroup.state);
    }, 750));
    this.__selectSubscription = this.__groupEventBus.subscribe(SelectEvent, msg => {
      this.handleCurrentGroup(msg);
      if (this.groupData && this.groupData.id != msg.groupId) {
        this.handleLocation();
      }
    });
  }

  unbind() {
    this.__selectSubscription.dispose();
  }

  // handleGroupEdit({groupId, data}) {
  //   let index = this.groupPath.findIndex(g => g.id === groupId);
  //   if (index > -1) {
  //     this.groupPath[index] = data;
  //   }
  // }

  handleCurrentGroup(state) {
    this.groupPath = get(state, 'groupPath', []);
  }

  handleLocation() {}

  handleCrumb(index) {
    let length = this.groupPath.length;
    index = length > this.pathLimit ? length - 1 + index - (this.pathLimit - 1) : index;

    let group = this.groupPath[index];
    if (group.isMember === true && group.id !== this.selectedGroup.id) {
      this.groupService.selectGroup({
        groupId: group.id, caller: this
      });
    }
  }

  handleRestCrumb() {
    let restGroupAmount = this.groupPath.length - this.pathLimit;
    let targetGroup = take(this.groupPath, restGroupAmount)
      .reverse().find(g => g.isMember);
    if (targetGroup) {
      this.groupService.selectGroup({
        groupId: targetGroup.id, caller: this
      });
    }
  }

  showApplication() {
    this.contentService.showGroupApplication();
  }

  showDirectory() {
    this.contentService.showGroupDirectory(this.selectedGroup.guid);
  }

  showSettings() {
    this.contentService.showGroupSettings(this.selectedGroup.id);
  }

  requestAffiliation() {
    this.groupService.affiliateWith(this.selectedGroup.id);
  }
  joinGroup() {
    this.groupService.join(this.selectedGroup.id);
  }
  showReports() {
    this.contentService.showGroupReports(this.selectedGroup.id);
  }

  showBilling() {
    this.contentService.loadContent(`billing/group-account/${this.userData.id}/${this.selectedGroup.guid}`);
  }
}

export class GroupTypeValueConverter {
  toView(value) {
    return capitalize(value);
  }
}

export class GroupListValueConverter {
  toView(value, limit = 0) {
    let result = value;
    let length = result.length;

    if (limit > 0 && length > 0) {
      let tmpList = result;
      if (length > limit) {
        result = tmpList.slice(-limit);
      } else {
        tmpList[0] = defaults({
          name: 'Master'
        }, tmpList[0]);

        result = tmpList;
      }
    }

    return result;
  }
}
